import BasicModal from "../Modals/BasicModal";
import AdminEditForm from "../../Pages/Admins/AdminEditForm";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/css/pages/admins.css";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";

const AdminProfileCard = ({ admin, setAdmin }) => {
    const [errors, setErrors] = useState({});
    const [newAdmin, setNewAdmin] = useState({})
    const [updateStatus, setUpdateStatus] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        setNewAdmin(admin)
    }, [admin])

    return (
        <div className="admin-profile card mb-5 mb-xl-8">
            <div className="card-body ls-1">
                <div className="">
                    <div
                        className="avatar"
                        style={{
                            background: `url(${admin?.avatar ? admin.avatar : avatarBlank})`
                        }}
                    ></div>
                    <h3 className="d-inline-block ml-3">{admin?.first_name} {admin?.last_name}</h3>
                </div>
                <div className="d-flex flex-stack fs-4 py-7">
                    <div className="fw-bolder rotate collapsible" role="button">
                        Details
                    </div>
                    <span data-bs-toggle="tooltip" data-bs-trigger="hover"
                        title="Edit customer details">
                        <button
                            className="btn btn-sm btn-light-primary"
                            onClick={() => { navigate('/admins/' + admin?.id + '/edit') }}
                        >
                            Edit
                        </button>
                    </span>
                </div>
                <div className="separator"></div>
                <div id="kt_user_view_details" className="collapse show mt-7">
                    <div className="pb-5 fs-6">
                        <div className="fw-bolder mt-5">Role</div>
                        <div className={`text-white fw-bolder bg-${admin?.role_name != "" ? 'primary' : 'danger'} px-3 py-1 rounded d-inline-block`}>
                            {admin?.role_name != "" ? admin?.role_name : 'Undefined'}
                        </div>
                        <div className="fw-bolder mt-5">Active</div>
                        <div className="text-gray-600">
                            <span
                                className={`bg-${admin?.is_active ? "success" : "danger"} mt-1 px-3 d-inline-block rounded py-1 text-white fw-bolder fs-6`}>
                                {admin?.is_active ? "True" : "False"}
                            </span>
                        </div>
                        <div className="fw-bolder mt-5">Personal Number</div>
                        <div className="text-gray-600">{admin?.personal_number ? admin?.personal_number : <div className="text-danger">N/A</div>}</div>
                        <div className="fw-bolder mt-5">Email</div>
                        <div className="text-gray-600">
                            <a href="#"
                                className="text-gray-600 text-hover-primary">{admin?.email ? admin?.email : <div className="text-danger">N/A</div>}</a>
                        </div>
                        <div className="fw-bolder mt-5">Phone</div>
                        <div className="text-gray-600">{admin?.phone ? admin?.phone : <div className="text-danger">N/A</div>}</div>
                        <div className="fw-bolder mt-5">Birthday</div>
                        <div className="text-gray-600">{admin?.birthday ? admin?.birthday : <div className="text-danger">N/A</div>}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminProfileCard;